<div class="modal-header bg-dark text-white">
  <h3 class="mb-0" id="modal-basic-title">Generating PDF Report</h3>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
  </button>
</div>
<div class="modal-body">
  <p class="text-muted mb-4">Large Report Detected (109 locations)</p>

  <div class="alert alert-light text-start" role="alert">
    Due to the report size, it will be generated in the background and emailed to you when ready.
  </div>

  <div class="mb-3">
    <div class="progress" style="height: 6px;">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" style="width: 45%;"></div>
    </div>
  </div>

  <p class="small text-muted mb-0">This typically takes up to <strong>5 minutes</strong>.</p>

</div>
<div class="modal-footer">
  <jft-submit-button (onClick)="submit()" [class]="'btn btn-dark text-white'" [title]="'Generate & Email Report'"
    [loadingTitle]="'Requesting...'" triggers="mouseenter:mouseleave" placement="right">
  </jft-submit-button>
  <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
